export const SUBJECT_COLORS = {
  'Math': { bg: '#e6f1f8', border: '#0072B2', text: '#005a8c' },
  'Science': { bg: '#e0f5ed', border: '#009E73', text: '#007a59' },
  'English': { bg: '#fdf3d7', border: '#E69F00', text: '#b37a00' },
  'History': { bg: '#fae3d0', border: '#D55E00', text: '#a84900' },
  'Art': { bg: '#f7e4ef', border: '#CC79A7', text: '#a35d85' },
  'Music': { bg: '#ddeef9', border: '#56B4E9', text: '#2a7ab5' },
  'Physical Education': { bg: '#fcf8d1', border: '#C4B200', text: '#8a7d00' },
  'Social Studies': { bg: '#e8e8e8', border: '#444444', text: '#333333' },
  'Foreign Language': { bg: '#ddeee0', border: '#117733', text: '#0d5c28' },
  'default': { bg: '#ebebeb', border: '#555555', text: '#444444' }
};

export const getSubjectColor = (subject) => {
  return SUBJECT_COLORS[subject] || SUBJECT_COLORS['default'];
};
